"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionOptions = exports.CommissionOption = void 0;
var CommissionOption;
(function (CommissionOption) {
    CommissionOption["Advantage"] = "Advantage";
    CommissionOption["Plus"] = "Plus";
    CommissionOption["Security"] = "Security";
    CommissionOption["ZeroOne"] = "ZeroOne";
})(CommissionOption = exports.CommissionOption || (exports.CommissionOption = {}));
exports.CommissionOptions = Object.values(CommissionOption);
//# sourceMappingURL=commission-option.js.map